// Before each route evaluates...
function middlewarePipeline (context, middleware, index) {
    const nextMiddleware = middleware[index]

    if (!nextMiddleware) {
        return context.next
    }

    return param => {

        // Run the default Vue Router `next()` callback first.
        if (param) return context.next(param)

        const nextPipeline = middlewarePipeline(
            context, middleware, index + 1
        )

        // Then run the subsequent Middleware with a new
        // `nextMiddleware()` callback.
        nextMiddleware({ ...context, next: nextPipeline })
    }
}

export default middlewarePipeline